function RouteGuard({ children }: { children: any }) {
  // const location = useLocation();
  // if (location.pathname === "/") {
  //   history.back();
  // }
  return children;
}
export default RouteGuard;
